export default __webpack_public_path__ + "static/media/logo-sandhiya.fe5c4657.png";